import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme } from '@mui/material/styles';
import React, { useMemo } from 'react';
import components from './components';
import palette from './palette';
import typography from './typography';
const ThemeProvider = ({ children }) => {
    const themeOptions = useMemo(() => ({
        typography,
        palette,
        components,
    }), []);
    const theme = createTheme(themeOptions);
    return (React.createElement(MUIThemeProvider, { theme: theme },
        React.createElement(CssBaseline, null),
        children));
};
export default ThemeProvider;
